// DS: C139 (loosely)
import React from 'react';
import cs from 'classnames';
import { useTranslation } from 'react-i18next';
import { useFlag } from '../../redux/flags/hooks';
import Button from '../../Button';
import s from './FallbackEditorBanner.scss';
export var FallbackEditorBanner = function (_a) {
    var onAccept = _a.onAccept;
    var t = useTranslation().t;
    var networkbar = useFlag('networkbar');
    return (React.createElement("div", { className: cs(s['root'], networkbar && s['networkbar']) },
        React.createElement("div", { className: s['details'] }, t('popup.fallbackEditorBanner.text')),
        React.createElement("div", { className: s['buttons'] },
            React.createElement(Button, { view: "b2", height: "small", minWidth: "120px", fullWidth: true, onClick: onAccept, className: s['accept'] }, t('popup.fallbackEditorBanner.accept')))));
};
FallbackEditorBanner.displayName = 'FallbackEditorBanner';
export default FallbackEditorBanner;
//# sourceMappingURL=FallbackEditorBanner.js.map